import {isEmpty, isUndefined} from 'lodash';
import request from './request';
import Bugsnag from "@bugsnag/js";

export const emailExistsInSystem = (email, auth) => request({
  url: 'api/v2/users/account-exists/',
  method: 'POST',
  data: {
    email,
    provider: isEmpty(email) ? 'google' : 'normal'
  },
  auth
});

export const getCurrentProfileByGoogle = (auth) => request({
  url: 'api/v2/users/profile/',
  method: 'GET',
  auth,
}).catch((e) => {
  Bugsnag.notify(e.originalError, (event) => {
    event.addMetadata('responseBody', e.response);
    event.addMetadata('errorMessage', e.message);
  });
});

export const sendOtp = (email, num_otp = 6) => request({
  url: 'api/v2/users/send-otp/',
  method: 'POST',
  data: {
    email,
    num_otp,
  }
});

export const sendPasswordResetOtp = (email) => request({
  url: 'api/v2/users/reset-password/',
  method: 'POST',
  data: {
    email
  }
});

export const verifyOtp = ({email, otp}) => request({
  url: 'api/v2/users/confirm-otp/',
  method: 'POST',
  data: {
    email, otp
  }
});

export const verifyOtpForResetOtp = ({email, otp}) => request({
  url: 'api/v2/users/verify-otp/',
  method: 'POST',
  data: {
    email, otp
  }
});

export const signup = (signupDetails, auth) => {
  if (signupDetails.provider === 'google') {
    return request({
      url: 'api/v2/users/signup/',
      method: 'POST',
      data: signupDetails,
      auth
    });
  } else {
    return request({
      url: 'api/v2/users/signup/',
      method: 'POST',
      data: signupDetails,
    });
  }
};

export const getDeclaration = (role) => request({
  url: `api/v2/declarations/?type=${role}`,
  method: 'GET'
});

export const getProjects = () => request({
  url: 'api/v3/project-list/',
  method: 'GET'
});

export const resetPassword = ({email, otp, password, confirmPassword}) => request({
  url: 'api/v2/users/confirm-password/',
  method: 'POST',
  data: {
    email, otp, newPassword: password, checkNewPassword: confirmPassword
  }
});


export const updateProfile = (data, auth) => {
  const formData = new FormData();
  formData.append("first_name", data.firstName);
  formData.append("last_name", data.lastName);
  formData.append("bio", data.bio);
  !isUndefined(data.picture) && formData.append("picture", data.picture);
  formData.append("phone_number", data.phoneNumber);
  request({
    url: 'api/v2/users/profile/',
    method: 'PUT',
    data: formData,
    auth,
  });
};

export const fetchSystemStatus = () => request({
  url: `api/v2/users/system_status/`,
  method: 'GET',
});

export const acceptTermsAndCondition = (auth) =>
  request({
    url: 'api/v2/users/agreement/',
    method: 'POST',
    data: {
      has_agreed_terms: true,
    },
    auth,
});

export const ncsDecryptParams = (params) => request({
  url: 'api/v2/users/ncs/params-decrypt/',
  method: 'POST',
  data: params
});

export const ncsSignUp = (ncsSignupDetails) => request({
  url: 'api/v2/users/ncs/signup/',
  method: 'POST',
  data: ncsSignupDetails
});

export const ncsSignIn = ({email, password}) => request({
  url: 'api/v2/users/ncs/signin/',
  method: 'POST',
  data: {
    email,
    password
  }
});

export const ncsUserExistsInSystem = (email) => request({
  url: 'api/v2/users/ncs/user-exists/',
  method: 'POST',
  data: {
    email,
  }
});

export const getNcsSurveyQuestions = (institutionCode) => {
  return request({
    url: 'api/v2/users/ncs/survey-questions/',
    method: 'GET',
    params: {
      institution_code: institutionCode
    }
  });
};

export const ncsSsoLogin = ({ token, clientId }) => request({
  url: 'api/v2/users/ncs/sso-login/',
  method: 'POST',
  data: {
    token,
    clientId,
  }
});
